export default "__VITE_ASSET__CEFMiyZ5__"